import { connect } from 'react-redux';
import { 
	setSearchQueryAction,
	searchFlickrAction,
	toggleSearchStartedAction,
	toggleSearchCompletedAction,
	adjustUIOnPageLoadAction
} from '../flickr-redux/actions';
import Search from './Search';

const mapStateToProps = (state) => {
	return {
		searchQuery: state.search.searchQuery,
		searchStarted: state.search.searchStarted,
		searchCompleted: state.search.searchCompleted,
		photos: state.photos.photos
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		onSearchClick: (searchQuery) => {
			dispatch(searchFlickrAction(searchQuery, 1));
		},
		onSearchQueryInput: (searchQuery) => {
			dispatch(setSearchQueryAction(searchQuery));
		},
		toggleSearchStarted: () => {
			dispatch(toggleSearchStartedAction());
		},
		toggleSearchCompleted: () => {
			dispatch(toggleSearchCompletedAction());
		},
		dispatchAdjustUI: () => {
			dispatch(adjustUIOnPageLoadAction())
		}
	}
}

const SearchContainer = connect(mapStateToProps, mapDispatchToProps)(Search);
export default SearchContainer;



/** WEBPACK FOOTER **
 ** ./src/search/SearchContainer.js
 **/